import { render } from "./DynamicDownload.vue?vue&type=template&id=6fde446a&scoped=true"
import script from "./DynamicDownload.vue?vue&type=script&lang=js"
export * from "./DynamicDownload.vue?vue&type=script&lang=js"

import "./DynamicDownload.vue?vue&type=style&index=0&id=6fde446a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fde446a"]])

export default __exports__